import { render, staticRenderFns } from "./sliderCode.vue?vue&type=template&id=47585118&scoped=true&"
import script from "./sliderCode.vue?vue&type=script&lang=js&"
export * from "./sliderCode.vue?vue&type=script&lang=js&"
import style0 from "./sliderCode.vue?vue&type=style&index=0&id=47585118&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47585118",
  null
  
)

export default component.exports